import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PPMetricsCards from "../payrole-tabs/PPMetricsCards";
import PPGymStatusSection from "../payrole-tabs/PPGymStatusSection";
import { fetchGymOverviewStatsData } from "../../../redux/payrole-reducers/payroleSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";

const GymOverview = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    gymOverviewStatsData,
    gymOverviewStatsLoading,
    gymOverviewStatsError,
  } = useSelector((state) => state.payrole);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedMonth: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    gym_id: allFilters.selectedGym?.value || "",
    month: allFilters.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniStats = {
    allStats: {},
    allStatsData: [],
  };
  const [statsData, setStatsData] = useState(iniStats);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const getGymOverviewStats = (filters) => {
    dispatch(
      fetchGymOverviewStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getGymOverviewStats(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !gymOverviewStatsLoading &&
      !gymOverviewStatsError &&
      gymOverviewStatsData?.status
    ) {
      setStatsData((prevs) => ({
        ...prevs,
        allStats: gymOverviewStatsData?.stats || {},
        allStatsData: gymOverviewStatsData?.data || [],
      }));
    } else {
      setStatsData(iniStats);
    }
  }, [gymOverviewStatsLoading, gymOverviewStatsError, gymOverviewStatsData]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isClusterManager && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      month: allFilters.selectedMonth?.value || "",
    }));
  }, [allFilters.selectedGym, allFilters.selectedMonth]);

  return (
    <>
      <CmnFilters
        from={"payrole-gym-overview"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        isLoading={gymOverviewStatsLoading}
      />
      <br />

      <PPMetricsCards metrics={statsData.allStats} />

      <PPGymStatusSection
        gymsData={statsData.allStatsData}
        userInfoData={userInfoData}
        callFunction={() => getGymOverviewStats(filters)}
        prevAllFilters={allFilters}
      />
    </>
  );
};

export default GymOverview;
